import { css } from '@emotion/react';
import { TranscriptionNotAvailable } from '@frontend/call-intel#svg';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';

export const DeferredCallAnalysisState = () => {
  const { t } = useTranslation('call-intel-core');

  return (
    <div css={styles.wrapper} data-testid='deferred-call-analysis-state'>
      <TranscriptionNotAvailable width={240} />
      <Text textAlign='center' color='subdued'>
        {t('Calls over 5 minutes take extra time to process. Check back soon.')}
      </Text>
    </div>
  );
};

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-md);
    align-items: center;

    p {
      width: 336px;
    }
  `,
};
